export class UserModel {
  public id: number;
  public email: string;
  public password: string;
  public confirmPassword: string;
  public firstName: string;
  public lastName: string;
  public client: string;
  public clientId: number;
  public position: string;
  public role: string;
  public active: boolean;
  public dateCreated: number;
  public listEnumRoles: Role[];
  public surveys: string[];
  public allowImportTypeForm: boolean;
  public allowImportSurveyMonkey: boolean;
  public allowImportCSV: boolean;
}

export class Role {
  public value: string;
  public id: string;
  public name: string;
}

export class NewPasswordModel {
  public confirmHash: string;
  public newPassword: string;
  public confirmPassword: string;
}



// WEBPACK FOOTER //
// ./src/app/models/user/users.model.ts